import React, { Component } from 'react';

class Banner extends Component {
    render() {
        return (
            <section className="landing__banner">
				<div className="container-fluid">
					<div className="row">
						<div className="col-md-6">
							<h1 className="landing__banner--heading">Personalised Skincare routine that is truly Yours</h1>
							<p>Swiss made skincare routine, tailored to your skin, lifestyle and environment.</p>
							<button type="button" class="btn btn-primary theme_btn">GET TRIAL SET- $15</button>
							<span>Buy our minis $15, get $15 back when you<br />buy the full size set*, so it’s actually FREE!</span>
						</div>
						<div className="col-md-6 text-center">
							<img className="mw-100" src="images/assessment/landing-banner.png" />
							<div className="row landing__banner--icon">
								<div className="col">
									<img src="/images/clean-beauty11.svg" />
								</div>
								<div className="col">
									<img src="/images/switzerland-txt.svg" />
								</div>
								<div className="col">
									<img src="/images/cruelty-free11.svg" />
								</div>
								<div className="col">
									<img src="/images/environmentally-friendly11.svg" />
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
        );
    }
}


export default Banner;